<template>
  <div class="container">
    <div class="left">
      <div style="display: flex; align-items: center;margin-bottom: 8px;">
        <div style="width: 76px; text-align: right;">{{$t("page_cps_time_select")}}:</div>
        <div style="width: 100%;flex:1;margin-left: 8px;">
          <a-range-picker
              :allowClear="true"
              :value="[moment(params.startTime), moment(params.endTime)]"
              :format="'YYYY-MM-DD'"
              @change="rangeChange"
          />
        </div>
      </div>
      <a-select
            allowClear
            show-search
            :placeholder="$t('search')"
            :value="customerId"
            :default-active-first-option="false"
            :show-arrow="false"
            :filter-option="false"
            :not-found-content="null"
            @focus="handleCustomerSearch"
            @search="handleCustomerSearch"
            @change="handleCustomerChange"
            style="width: 100%;margin-bottom: 8px;"
          >
            <a-select-option v-for="d in customerList" :key="d.value">
              {{ d.text }}
            </a-select-option>
          </a-select>
      <div style="height: calc(100% - 120px);margin-bottom: 8px;">
        <Tree @getTreeData="getValue" :tree-data="treeData" :customerInfo="customerInfo" :expandKeys="expandKeys"/>
      </div>
      <div style="text-align: right;padding-right: 8px;">
        <a-button type="primary" @click="search">
          {{ $t('page_time_analysis_search') }}
        </a-button>
      </div>
    </div>
    <div class="right">
      <div class="item">
        <div class="title">
          <div>
            {{$t('page_ops_work_record_industry_classification')}}
          </div>
          <a-radio-group v-model="mode1" :style="{ marginBottom: '8px' }">
            <a-radio-button value="pie">{{$t('page_work-record_pie')}}</a-radio-button>
            <a-radio-button value="bar">{{$t('page_work-record_bar')}}</a-radio-button>
          </a-radio-group>
        </div>
        <div style="height: calc( 100% - 21px)">
          <chart-view width="1200px" height="600px" :chart-option="pie1Option" id="pie-1" v-show="mode1 === 'pie' && !isNull(pie1Option)"/>
          <chart-view width="1200px" height="600px" :chart-option="bar1Option" id="bar-1" v-show="mode1 === 'bar' && !isNull(bar1Option)" />
          <template v-if="isNull(pie1Option) && isNull(bar1Option)">
              <div class="empty">
                <img src="../../../../assets/images/noDevice.png"/>
                <p>{{ $t('page_extranet_no_device') }}</p>
              </div>
          </template>
        </div>
      </div>
      <div class="item">
        <div class="title">
          <div>
            {{$t('page_ops_work_record_job_classification')}}
          </div>
          <a-radio-group v-model="mode2" :style="{ marginBottom: '8px' }">
            <a-radio-button value="pie">{{$t('page_work-record_pie')}}</a-radio-button>
            <a-radio-button value="bar">{{$t('page_work-record_bar')}}</a-radio-button>
          </a-radio-group>
        </div>
        <div style="height: calc( 100% - 21px)">
          <chart-view width="1200px" height="600px" :chart-option="pie2Option" id="pie-2" v-show="mode2 === 'pie' && !isNull(pie2Option)"/>
          <chart-view width="1200px" height="600px" :chart-option="bar2Option" id="bar-2" v-show="mode2 === 'bar' && !isNull(bar2Option)" />
          <template v-if="isNull(pie1Option) && isNull(bar1Option)">
              <div class="empty">
                <img src="../../../../assets/images/noDevice.png"/>
                <p>{{ $t('page_wm_empty') }}</p>
              </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Tree from "./components/tree"
import chartView from "@/components/chart/index.vue"
import options from "@/components/chart/index"
import { WorkRecordServiceProxy,WorkRecordStatisticsServiceProxy } from '@/service-proxies/app-v2/work-record.service-proxies'
import {CustomerServiceProxy as mccsp } from "@/service-proxies/app-v2/masterlink-cps-client.service-proxies"
const api = new mccsp();
import { getTenantInfo } from '@/utils/auth'
import dayjs from "dayjs";
import moment from 'moment';

const wrsp = new WorkRecordServiceProxy()
const workRecordStatisticsServiceProxy = new WorkRecordStatisticsServiceProxy()

let timeout;
let currentValue;
function fetchCustomers(value, callback) {
  if (timeout) {
    clearTimeout(timeout);
    timeout = null;
  }
  currentValue = value;

  function getCustomers() {
    api.getCustomers(value).then((result) => {
      if (currentValue === value) {
        const data = [];
        result.forEach((r) => {
          data.push({
            value: r["id"],
            text: r["name"],
          });
        });
        callback(data);
      }
    });
  }
  timeout = setTimeout(getCustomers, 120);
}
 export default {
  components: { Tree, chartView },
   data() {
     return {
       treeData: [],
       pie1Option : {},
       pie2Option : {},
       bar1Option: {},
       bar2Option: {},
       params: {
         type: '',
         areaName: '',
         cityName: '',
         provinceName: '',
         customerId: '',
         startTime:dayjs().subtract(7, 'days').format('YYYY-MM-DD'),
         endTime: dayjs().subtract(0, 'days').format('YYYY-MM-DD'),
       },
       mode1: 'pie',
       mode2: 'pie',
       customerId: undefined,
       customerList: [],
       customerInfo: {},
       expandKeys: []
     }
   },
   created() {
     this.getTreeList()
   },
   methods: {
     moment,
     isNull(obj) {
       return Object.keys(obj).length === 0
     },
     async getTreeList() {
       const tenant = getTenantInfo()
       const tenantCode = tenant ? tenant : '根节点'
       const treeData = [
         {
           code: '00-00',
           id: 0,
           name: tenantCode,
           level: 0,
         }
       ]
       const { data } = await api.getRegionCustomerDetail();
       treeData[0].children = data;
       this.treeData = treeData;
       this.http();
     },
     rangeChange(value) {
       if (value && value.length) {
         this.params.startTime = dayjs(value[0]).format('YYYY-MM-DD')
         this.params.endTime = dayjs(value[1]).format('YYYY-MM-DD')
       }
     },
     getValue({data}) {
       this.resetParams();
       const {level, name,code:id } =data;
       switch (level){
         case 1:
           this.params.areaName =name;
           break;
         case 2:
           this.params.provinceName =name;
           break;
         case 3:
           this.params.customerId =id;
           break;
       }
     },
     resetParams() {
       const params= {
         type: '',
         areaName: '',
         cityName: '',
         provinceName: '',
         customerId: ''
       }
       this.params = {...this.params, ...params};
     },
     sum(arr) {
       return arr.reduce(function(acr, cur){
         return acr + cur;
       });
     },
     search() {
        this.http();
     },
     async http() {
       this.pie1Option = {}
       this.pie2Option = {}
       this.bar1Option = {}
       this.bar2Option = {} 
       const industryData = await this.drawChart({type:1});
       const jobData = await this.drawChart({type:2});
       if(industryData){
         this.pie1Option = options.pie(industryData.pie);
         this.bar1Option = options.bar(industryData.bar.axis, industryData.bar.data);
       }
       if(jobData) {
         this.pie2Option = options.pie(jobData.pie);
         this.bar2Option = options.bar(jobData.bar.axis, jobData.bar.data);
       }
     },
     drawChart(data) {
       const p = {...this.params, ...data}
       if(p.startTime){
         p.startTime = p.startTime+' 00:00:00'
       }
       if(p.endTime){
         p.endTime = p.endTime+' 23:59:59'
       }
        return new Promise((resolve, reject) => {
          workRecordStatisticsServiceProxy.getIndustryOrJobWorkRecordStatistics(p).then(res=>{
           const obj = {
             pie: [],
             bar: []
           }
          res = res.filter(re => re.value != 0)
          if (res.length === 0) {
            resolve()
            return
          }
          const arr = res.map(v=>v.value);
          const total = this.sum(arr);
          const list = res.map(v=>{
            if(total!==0 && v.value !== 0){
              v.name = v.name +'-'+ ((v.value/total)*100).toFixed(0)+ '%';
            }else{
              v.name = v.name +'-' + '0%'
            }
            return v;
          });
          obj.pie = list
          const data= res.map(v=>v.value);
          const axis = res.map(v=>v.name);
          obj.bar = {data,axis}
          resolve(obj)
         })
       });

     },
    handleCustomerSearch(value) {
      value = value === undefined ? undefined : value;
      fetchCustomers(value, (data) => (this.customerList = data));
    },
    handleCustomerChange(value) {
      value = value === undefined ? undefined : value;
      this.customerId = value;
      fetchCustomers(value, (data) => (this.customerList = data));
      // id 获取地址
      this.customerInfo = this.customerList.find(v=>v.value===value) || {};
      document.getElementsByClassName('ant-tree-node-content-wrapper').forEach(res => {
        if (res.innerText === this.customerInfo.text) {
          res.scrollIntoView()
        }
      })
    },
   }
 }
</script>
<style lang="less" scoped>
.title{
  display: flex;
  justify-content: space-between;
}
.container{
  display: flex;
  width: 100%;
  height: 100%;
  background-color: #f0f2f5;
  padding-bottom: 0px;
}
.left{
  background: #ffffff;
  min-width: 310px;
  width: 310px;
  height: 100%;
  border: 1px solid #d7d7d7;
  padding: 8px;
}
.right{
  overflow-y: auto;
  background: #ffffff;
  margin-left: 10px;
  flex: 1;
  width: 1px;
  height: 100%;
  border: 1px solid #d7d7d7;
}
.item{
  min-height: 50%;
  padding: 10px;
  &:first-child{
    border-bottom: 1px solid #d7d7d7;
  }
}
.empty{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;
}
</style>